import { Box } from '@chronosphereio/chrono-ui';
import { useDataQueryResult } from '@/plugin-system';
import { StatusHistoryPanelLoaded } from './StatusHistoryPanelLoaded';
import { StatusHistoryProps } from './status-history-models';

export function StatusHistoryPanel(props: StatusHistoryProps) {
  const { queryResults, isFetching } = useDataQueryResult({ dataTypeFilter: 'TimeSeries' });
  if (queryResults[0]?.error) throw queryResults[0]?.error;

  const { width, height } = props;

  if (width === undefined || height === undefined) return null;

  return (
    <Box width={width} height={height} data-testid="statusHistory" sx={{ overflow: 'hidden' }}>
      <StatusHistoryPanelLoaded {...props} queryResults={queryResults} isFetching={isFetching} />
    </Box>
  );
}
